import { zSchema, schemes } from "@zeal/common";

export const updateOrderRequestSchema = zSchema.object({
  companyID: schemes.uuid(),
  orderID: schemes.uuid(),
  flat: zSchema.number().optional(),
  memo: zSchema.string().optional(),
  contractor_payments: zSchema.array(schemes.mongoObjectId()).optional(),
  approved: zSchema.boolean().optional(),
});

export type TUpdateOrderRequestSchema = zSchema.infer<
  typeof updateOrderRequestSchema
>;

export const updateOrderResponseSchema = zSchema.object({
  companyID: schemes.uuid(),
  customerAccountID: schemes.uuid(),
  orderID: schemes.uuid(),
  businessCardID: zSchema.string().optional(),
  approval_required: zSchema.boolean(),
  approved: zSchema.boolean(),
  contractor_payments: zSchema.array(schemes.mongoObjectId()).optional(),
  flat: zSchema.number(),
  last_four: zSchema.string().optional(),
  memo: zSchema.string().optional(),
  order_total: zSchema.number(),
  payment_receipt_link: zSchema.string().nullable(),
  status: zSchema.string(),
  submitted_at: zSchema.date().optional(),
});

export type TUpdateOrderResponseSchema = zSchema.infer<
  typeof updateOrderResponseSchema
>;
